import { Component, AfterViewInit, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthenticationService } from '../../../authentication.service';
import { ProfileService } from '../../../portal/service/profile.service';
import { MainService as Portal_main } from '../../../portal/service/main.service';
import { MainService } from '../../service/main.service';
import { Router } from '@angular/router';
import { session } from '../../../../environments/environment.session';

@Component({
  selector: '[app-hrms-header]',
  templateUrl: './hrms-header.component.html',
  styleUrls: ['./hrms-header.component.css']
})

export class HrmsHeaderComponent implements AfterViewInit {
  constructor(private router: Router, public portal_main: Portal_main, public mainService: MainService,
    public auth: AuthenticationService, private profileService: ProfileService, private sanitizer: DomSanitizer) { }

  erpUser :any= {};
  noti_count :any= 0;
  noti_data:any;
  message_count:any;
  hidden = true;
  async ngOnInit() {
  
    console.log(this.portal_main.accInfo)
    this.erpUser = JSON.parse(atob(session['erpUser']));
    let dd = [];
    dd = this.erpUser['role_cd']
    if (dd.includes("AA")) {
      this.hidden = false;
    } else {
      this.hidden = true
    }
    await this.portal_main.getUserImage(this.erpUser['user_id']);
    await this.portal_main.getAccImage(this.erpUser['b_acct_id']);
    await this.portal_main.getAccountInfo(this.erpUser['b_acct_id']);
    await this.portal_main.getHeaderInfo(this.erpUser['b_acct_id']);
    await this.changeLanguage();
    let data = await this.portal_main.getNotification(this.erpUser['b_acct_id'], this.erpUser['user_id']);
    this.noti_count = data.noti_count;
    this.noti_data = data.noti_data;
    let message = await this.portal_main.getMessageCount(this.erpUser['b_acct_id'], this.erpUser['user_id']);
    console.log(message)
    this.message_count = message.length;
    console.log(this.message_count)
  }

  changeLanguage() {
    console.log("laungage Change");
    this.mainService.language_cd = this.auth.language_cd
  }


  ngAfterViewInit() {
  }

}